import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="font-heading text-xl text-white mb-4 block cursor-pointer">
              黑料吃瓜网
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              免费高清完整视频在线播放平台，提供最新爆料吃瓜内容。一区二区即点即播，无需下载，畅享精彩内容。
            </p>
          </div>
          <div>
            <h4 className="font-heading text-white text-sm font-semibold mb-4">
              <a href="#footer-categories" className="cursor-pointer">分区导航</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-white text-sm font-semibold mb-4">
              <a href="#footer-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors duration-200 cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors duration-200 cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#privacy" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors duration-200 cursor-pointer">隐私政策</a>
              </li>
              <li>
                <a href="#terms" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors duration-200 cursor-pointer">用户协议</a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-white text-sm font-semibold mb-4">
              <a href="#footer-contact" className="cursor-pointer">联系我们</a>
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                <span>contact@heiliaochigua.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-customer-service-2-line w-4 h-4 flex items-center justify-center"></i>
                <span>在线客服：7×24小时</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between">
          <p className="text-xs text-foreground-500">
            &copy; 2026 黑料吃瓜网 - 版权所有。本站内容仅供学习交流，请勿用于商业用途。
          </p>
          <div className="flex items-center gap-4 mt-3 sm:mt-0">
            <a href="#weibo" className="text-foreground-500 hover:text-accent-300 transition-colors duration-200 cursor-pointer" rel="nofollow">
              <i className="ri-weibo-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#wechat" className="text-foreground-500 hover:text-accent-300 transition-colors duration-200 cursor-pointer" rel="nofollow">
              <i className="ri-wechat-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}